import axios, { buildApi } from '@/libs/api.request';
let name = '/finance/stock'

export const apis = buildApi({
  get: [name + '/index&list', name + '/info', name + '/sku'],
  post: [name + '/create_bill'],
})

export const exportApi = (params) => {
  return axios.request({
    url: `/warehouse/skuDaliy/exportSummary`,
    method: 'POST',
    params
  })
}
